// An app page opened from /designs offers "Back to designs" without a ?return= in its URL: the
// library remembers which app it opened for this tab.
const KEY = 'ast-from-designs';

export function rememberDesignsOpen(appStoreId: number) {
  try {
    sessionStorage.setItem(KEY, String(appStoreId));
  } catch {}
}

/** True when this tab opened the app at `pathname` from /designs. */
export function openedFromDesigns(pathname: string | null | undefined): boolean {
  const id = /^\/app\/.*-(\d+)$/.exec(pathname ?? '')?.[1];
  if (!id) return false;
  try {
    return sessionStorage.getItem(KEY) === id;
  } catch {
    return false;
  }
}
